<template>
	<div>
		<p>
			<FormTitleText titleText="区分" />
			<RequiredIcon v-if="rules && rules.includes('required')" />
		</p>
		<p>{{ computedCategory }}</p>
	</div>
</template>

<script>
import FormTitleText from '../Atoms/FormTitleText'
import RequiredIcon from '../Atoms/RequiredIcon'

export default {
	name: 'CategoryForm',
	props: ['category', 'rules'],
	mounted() {},
	computed: {
		computedCategory() {
			switch (this.category) {
				case 'ADULT':
				case 'STUDENT':
					return '大人'
				case 'CHILD':
					return '子ども'
				default:
					return '未設定'
			}
		}
	},
	methods: {},
	components: {
		FormTitleText,
		RequiredIcon
	}
}
</script>

<style lang="scss" scoped></style>
